import { render } from "./QuestionSet.vue?vue&type=template&id=4d0883c8&scoped=true"
import script from "./QuestionSet.vue?vue&type=script&lang=ts"
export * from "./QuestionSet.vue?vue&type=script&lang=ts"

import "./QuestionSet.vue?vue&type=style&index=0&id=4d0883c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d0883c8"

export default script